import { Button, Grid } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import RequestFormStepperStore, { STEP_COUNT } from './RequestFormStepperStore';

const STEP_LABEL_KEYS = [
  'request_form.stepper_step_1',
  'request_form.stepper_step_2',
  'request_form.stepper_step_3',
  'request_form.stepper_step_4',
  'request_form.stepper_step_5',
  'request_form.stepper_step_6',
  'request_form.stepper_step_7'
];

function RequestFormStepper() {
  const { t } = useTranslation();
  const { currentStep } = RequestFormStepperStore;

  return (
    <Grid container spacing={0.5}>
      {Array.from({ length: STEP_COUNT }, (_, i) => (
        <Grid item xs key={i}>
          <Button
            fullWidth
            variant='contained'
            color={currentStep === i ? 'primary' : 'success'}
            onClick={() => RequestFormStepperStore.setStep(i)}
            sx={{
              borderRadius: 0,
              textTransform: 'none',
              py: 1.5,
              fontSize: '0.72rem',
              lineHeight: 1.2,
              minHeight: 52
            }}
          >
            {`${i + 1}. ${t(STEP_LABEL_KEYS[i])}`}
          </Button>
        </Grid>
      ))}
    </Grid>
  );
}

export default observer(RequestFormStepper);
